import { IMAGE_BUCKET_URL, GET_QR_CODE, QR_DEPOSIT  } from "../../DataStore/ApiConstant";
import WhatsappButton from "../Cashier/whatsappButton";
import ImportantNotice from "./ImportantNotice";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import BonusOffer from "../TransactionCommon/BonusOffer";
import { useQRPayment } from "../../services/cashier";
import { useState } from "react";
import axios from "axios";

const QRPayment = () => {
  const [qrCode, setQrCode] = useState(null);
  const [walletAddress, setWalletAddress] = useState(null);
  const [provider, setProvider] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errmsg, setErrmsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [walletAddressMsg, setWalletAddressMsg] = useState("");

  const handleImageClick = async (endpoint) => {
    setProvider(endpoint);
    try {
      const response = await axios.get(GET_QR_CODE + endpoint);
      setQrCode(response.data.url);
      setWalletAddress(response.data.wallet_address);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching QR code:", error);
    }
  };
  const copyWalletAdress = () => {
    navigator.clipboard.writeText(document.getElementById('walletAddress').value);
    setWalletAddressMsg("Copied to clipboard!");
    setTimeout(() => {setWalletAddressMsg("") }, 3000);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    const utrNumber = document.getElementById("utrNumber").value;
    const bonusActivation = document.querySelector('input[name="bonus"]:checked')?.value;

    // // Ensure qrCode is properly set and derive providerID
    // let providerID = null;
    // if (provider) {
    //   if (provider.includes("upi")) providerID = "upi";
    //   else if (provider.includes("paytm")) providerID = "paytm";
    //   else if (provider.includes("phonepay")) providerID = "phonepay";
    //   else if (provider.includes("googlepay")) providerID = "googlepay";
    // }

    if (!utrNumber || !bonusActivation || !provider) {
      setErrmsg("Please fill in all fields before submitting.");
      setTimeout(() => {setErrmsg("") }, 3000);
      return;
    }

    try {
      const response = await axios.post(QR_DEPOSIT, 
      {
        "provider": "qr", 
        "bonus": parseInt(bonusActivation), 
        "UTRNo": utrNumber, 
        "fiatAmount": "0", 
        "providerID": provider,
        "currencyType": "LKR"
      }
    );
      setSuccessMsg("Payment submitted successfully!");
      setTimeout(() => {
        closeModal();
        setSuccessMsg("");
      }, 3000);
      
      
    } catch (error) {
      console.error("Error submitting payment:", error);
      setErrmsg("Failed to submit payment. Please try again.");
      setTimeout(() => {setErrmsg("") }, 3000);
    }
  };

  return (
    <>
      <div
        className="tab-pane fade"
        id="v-pills-QR"
        role="tabpanel"
        aria-labelledby="v-pills-settings-tab"
      >
        <div className="row d-flex justify-content-center visible">
          <div className="col-lg-2 col-md-2 col-sm-2 col-6 mx-0 p-2">
            <a onClick={() => handleImageClick("upi")}>
              <img src={IMAGE_BUCKET_URL + "upiQrImage.png"} className="clickableImage img-fluid" alt="" />
            </a>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2 col-6 mx-0 p-2">
            <a onClick={() => handleImageClick("paytm")}>
              <img
                src={IMAGE_BUCKET_URL + "paytmQrImage.png"}
                className="clickableImage img-fluid"
                alt=""
              />
            </a>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2 col-6 mx-0 p-2">
            <a onClick={() => handleImageClick("phonepay")}>
              <img
                src={IMAGE_BUCKET_URL + "phonepeQrImage.png"}
                className="clickableImage img-fluid"
                alt=""
              />
            </a>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2 col-6 mx-0 p-2">
            <a onClick={() => handleImageClick("googlepay")}>
              <img
                src={IMAGE_BUCKET_URL + "G-payQrImage.png"}
                className="clickableImage img-fluid"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show"
            id="qrpayment"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            style={{ display: 'block' }}
            aria-modal="true"
            role="dialog"
          >
            <div className="modal-dialog">
              <div className="modal-content bg-white text-black">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{ position: 'absolute', right: '15px' }}
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="qrpaymentTitel d-flex justify-content-center">
                    Scan The QR Code On Any UPI App to Make The Payment
                  </div>

                  <div className="qrpaymentBG d-flex justify-content-center align-items-center">
                    <div className="justify-content-center align-items-center">
                      {qrCode ? (
                        <img src={qrCode} className="img-fluid" alt="QR Code" style={{height: "180px"}}/>
                      ) : (
                        <p>Loading QR Code...</p>
                      )}
                    </div>
                  </div>

                  <div className="d-flex justify-content-center mb-2">
                    <div className="copy-text">
                      <input type="text" className="text" defaultValue={walletAddress} id="walletAddress" />
                      <button onClick={() => copyWalletAdress()}>
                        <i className="fa fa-clone" />
                      </button>
                    </div>
                  </div>
                  {walletAddressMsg && (
                          <div
                            style={{ marginTop: "30px" }}
                            className="alert alert-success d-flex justify-content-center"
                          >
                            {walletAddressMsg}
                          </div>
                        )}

                  <div className="qrpaymentText d-flex justify-content-center mb-2">
                    After making the payment please enter the UTR Number and mark whether you would like to activate bonus or not.
                  </div>

                  <div className="d-flex justify-content-center mb-2">
                    <div className="mb-3">
                      <label htmlFor="utrNumber" className="form-label">
                        UTR Number
                      </label>
                      <input type="text" className="form-control" id="utrNumber" />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center">
                    <div className="col-md-12 mb-3">
                      <div className="row">
                        <div className="col-12 text-center">
                          <label className="form-label" htmlFor="bonusActivation">
                            Bonus Activation
                          </label>
                        </div>
                        <div className="d-flex justify-content-center">
                          <div className="px-3">
                            <div className="form-check">
                              <input
                                style={{padding:"0"}}
                                className="form-check-input"
                                type="radio"
                                name="bonus"
                                id="bonusYes"
                                value="1"
                              />
                              <label className="form-check-label mt-1 ms-2" htmlFor="bonusYes">
                                Yes
                              </label>
                            </div>
                          </div>
                          <div className="px-3">
                            <div className="form-check">
                              <input
                                style={{padding:"0"}}
                                className="form-check-input"
                                type="radio"
                                name="bonus"
                                id="bonusNo"
                                value="0"
                                defaultChecked
                              />
                              <label className="form-check-label mt-1 ms-2" htmlFor="bonusNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="qrpaymentText d-flex justify-content-center mb-2">
                    Please click on the Submit button to continue
                  </div>
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 mb-3 justify-content-center">
                        {successMsg && (
                          <div
                            style={{ marginTop: "30px" }}
                            className="alert alert-success d-flex justify-content-center"
                          >
                            {successMsg}
                          </div>
                        )}
                        {errmsg && (
                          <div
                            style={{ marginTop: "30px" }}
                            className="alert alert-danger d-flex justify-content-center"
                          >
                            {errmsg}
                          </div>
                        )}
                    </div>
                </div>

                  <div className="d-flex justify-content-center">
                    <button type="button" className="btn btn-primary w-100" onClick={handleSubmit}>
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QRPayment;
